import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import type { PageClick } from '@/hooks/affiliate/useAffiliateAnalytics';

interface ClicksByPageChartProps {
  data: PageClick[];
}

export const ClicksByPageChart = ({ data }: ClicksByPageChartProps) => {
  // Take top 10 pages
  const topPages = data.slice(0, 10);

  return (
    <Card className="mt-6">
      <CardHeader>
        <CardTitle>Click-Through Rates by Page</CardTitle>
        <CardDescription>Pages driving the most affiliate clicks</CardDescription>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Page</TableHead>
              <TableHead className="text-right">Clicks</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {topPages.length > 0 ? (
              topPages.map((page, index) => (
                <TableRow key={index}>
                  <TableCell className="font-medium">
                    {page.page === '/' ? 'Home' : page.page}
                  </TableCell>
                  <TableCell className="text-right">{page.clicks}</TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={2} className="text-center text-muted-foreground">
                  No data available
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};
